import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME, VALID_BEHAVIORS, } from '../../common/constants.js';
export function validateWebView(nodeFields, accept) {
    const { idField, richAssetField, behaviorsField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetWebView(richAssetField?.content))
        return;
    if (ast.isStringField(richAssetField.content.value)) {
        // Add a deprecation warning
        accept('warning', `String content for webview is being deprecated. Please use the new JSON format.`, {
            node: richAssetField,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.nodeNumber,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
        const contentString = richAssetField.content.value.value.toLowerCase();
        // The string needs to be in the format label~url
        // Get the individual parts of the string
        const indexOfTilde = contentString.indexOf('~');
        if (indexOfTilde === -1) {
            accept('error', `The content is not formatted correctly. It should be in the format 'label~url'.`, {
                node: richAssetField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
        else {
            // Split the string into it's parts.
            const label = contentString.slice(0, indexOfTilde).trim();
            const url = contentString.slice(indexOfTilde + 1).trim();
            // Url is required and should be pointing to secure location
            if (!url) {
                accept('error', `Missing required 'url' value.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
            else if (url.startsWith('https://') === false) {
                accept('error', `URL should point to a secure (https) location.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
            if (!label) {
                // Empty/missing label value is only allowed if we have
                // inline behavior defined.
                let hasInlineBehavior = false;
                behaviorsField?.behaviors?.forEach((b) => {
                    if (b.value === VALID_BEHAVIORS.INLINE) {
                        hasInlineBehavior = true;
                    }
                });
                if (!hasInlineBehavior) {
                    accept('error', `Missing required 'label' value.`, {
                        node: richAssetField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: nodeFields.nodeNumber,
                            propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                        },
                    });
                }
            }
        }
    }
    else if (ast.isWebViewJson(richAssetField.content.value)) {
        const webViewJson = richAssetField.content.value;
        // Check for duplicate and required properties
        checkForDuplicateAndRequiredProperties({
            node: webViewJson,
            allProperties: webViewJson.properties,
            requiredProperties: [
                ast.TypeStaticProperty,
                ast.UrlProperty,
                ast.InlineProperty,
            ],
            parentNode: nodeFields.refNode,
            accept,
        });
        // The url should start with https.
        const urlProperty = webViewJson.properties.find((prop) => {
            return ast.isUrlProperty(prop);
        });
        const url = urlProperty?.url?.value?.toLowerCase();
        if (url && url.startsWith('https://') === false) {
            accept('error', `URL should point to a secure (https) location.`, {
                node: webViewJson,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
        // Also if 'inline' is present and set to false, then 'label'
        // should be present.
        const inlineProperty = webViewJson.properties.find((prop) => {
            return ast.isInlineProperty(prop);
        });
        if (inlineProperty && inlineProperty.inline.value === 'false') {
            const labelProperty = webViewJson.properties.find((prop) => {
                return ast.isLabelProperty(prop);
            });
            if (!labelProperty) {
                accept('error', `Missing required property 'label'.`, {
                    node: webViewJson,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
        }
    }
}
//# sourceMappingURL=web-view.js.map